<template lang="html">
  <div class="become-the-change">
    <div class="campaign-header small-top">
      <div class="image">
        <img :src="campaign.image" />
      </div>
      <div class="campaign-info-block">
        <social-links :link="pageAddress" class="social-links end"></social-links>
        <div class="campaign-info">
          <h1>{{campaign.name}}</h1>
          <h3>A create the change campaign</h3>
          <div class="campaign-blurb">
            {{campaign.short_description}}
          </div>
          <div class="progress small-top">
            <span class="progress-big-text">{{humanReadable(campaign.total)}}</span>
            <span class="progress-text"> of {{ humanReadable(campaign.max_points) }}</span>
            <!-- <progress-bar :current-progress="campaign.total" :max="campaign.max_points"></progress-bar> -->
            <div class="percintile-info" v-if="User.id && campaign.percentile >= 50">
              Your efforts put you in the top <b>{{ campaign.percentile }}% of Creators</b>! Well Done!
            </div>
            <div class="percintile-info" v-if="User.id && campaign.percentile < 50">
              Your efforts put you in the bottom <b>{{ campaign.percentile }}% of Creators</b>! Keep up the hard work!
            </div>
            <div class="percintile-info small-top" v-if="User.id">
              The average point contribution is <b>{{ campaign.avg }} points a day</b>
            </div>
          </div>
          <cta :campaign="$route.params.id" class="cta-btn" v-if="!User.id" ></cta>
        </div>
      </div>
    </div>
    <div class="section campaign-about">
      <div class="section-info campaign-about-info">
        <h2>How Create the Change Campaigns Work</h2>
        <div class="small-top">
          We all want to create the best world possible--for ourselves and for those around us. Our Create the Change campaign is a completely unique way to creating positive changes in ourselves while simultaneously creating a better world for others.
        </div>
        <div class="small-top">
          Creators of Change (people who join a Create the Change campaign) work with their own digital coach on their personal or professional development. Their digital coach will help them create goals and habits that will help them become their best selves. Each time a Creator does their daily exercise or makes progress toward their goal, Habit Technologies contributes to a cause or charity that makes the world a better place.  So when you change yourself for the better, you are also making the world better.
        </div>
        <div class="small-top">
          We create the change we want to see--inside and outside.
        </div>
        <cta :campaign="$route.params.id" class="cta-btn" v-if="!User.id">Become a Creator of Change</cta>
      </div>
      <div class="image">
        <img src="https://pbs.twimg.com/media/BcwkcDWCUAAZuxu.jpg" alt="">
      </div>
    </div>
    <div class="section about-ht">
      <div class="section-info">
        <h2>About Habit Technologies</h2>
        <div class="ht-info-text">
          Habit Technologies is dedicated to helping people become their best selves by providing them with digital coaching, habit training, and more. We partner with coaches, trainers, speakers, and consultants who are committed to helping their clients create deep and lasting change. If you would like to know more about partnering with Habit Technologies, visit us at
          <a href="https://habittechnologies.com" target="_blank">HabitTechnologies.com.</a>
        </div>
      </div>
    </div>
    <div class="section campaign-detail">
      <div class="image">
        <img :src="campaign.secondary" />
      </div>
      <div class="section-info campaign-about-info">
        <h3>About {{campaign.name}}</h3>
        <div class="">
          {{campaign.long_description}}
        </div>
        <a :href="campaign.url" target="_blank">Click to learn more</a>
        <cta :campaign="$route.params.id" class="cta-btn" v-if="!User.id">Join Campaign</cta>
      </div>
    </div>
  </div>
</template>

<script>
// import progressBar from "@/components/progressBar";
import socialLinks from "@/components/socialLinks";
import store from "@/services/api/store";
import cta from "./cta";
import User from "@/services/api/authUser";
const CAMPAIGN_STORE = "ChangeCampaign";

export default {
  components: {
    // progressBar,
    cta,
    socialLinks
  },
  data() {
    return {
      User,
      campaign: {}
    };
  },
  computed: {
    pageAddress() {
      return `/create-the-change/${this.campaign.id}/${this.campaign.slug}`;
    }
  },
  methods: {
    humanReadable(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  created() {
    store
      .find(CAMPAIGN_STORE, this.$route.params.id)
      .then(c => (this.campaign = c));
  }
};
</script>

<style lang="less" scoped>
.become-the-change {
  max-width: 1200px;
  margin: 0 auto;
  background-color: white;
  // padding: 10px;
  border-radius: 10px;
  overflow: hidden;
  .percintile-info {
    line-height: 30px;
  }
  .end {
    display: block;
    text-align: end;
  }
  h1,
  h3 {
    color: black;
    // text-transform: capitalize;
  }
  h1 {
    font-weight: 800;
  }
  .small-top {
    margin-top: 15px;
  }
  .dark {
    background-color: whitesmoke;
  }
  .progress-big-text {
    font-size: 30px;
    font-weight: bold;
  }
  .progress-text {
    font-size: 20px;
  }
  i {
    color: black !important;
  }
  .about-ht {
    background-image: url("https://images.unsplash.com/photo-1444927714506-8492d94b4e3d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=80");
    width: 100%;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    .section-info {
      display: flex;
      align-self: center;
      background-color: #ffffff;
      margin: 0px !important;
      padding: 40px !important;
      align-items: center;
      justify-content: center;
      text-align: center;
      opacity: 0.6;
      filter: alpha(opacity=60);
      @media (max-width: 720px) {
        height: 100%;
        text-align: left;
        padding: 5px;
      }

      .ht-info-text {
        width: 50%;
        font-weight: 500;
        color: #000000;
        @media (max-width: 720px) {
          width: 100%;
        }
      }
    }
  }
  .section {
    display: flex;
    flex-direction: row;
    margin-top: 30px;
    min-height: 50vh;
    height: 100%;
    @media (max-width: 720px) {
      flex-direction: column;
    }
    .cta-btn {
      width: 90%;
      margin: 10px;
      letter-spacing: 1px;
    }
    .section-info {
      flex: 3;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 10px 20px;
      margin: 10px 10px;
    }
    .image {
      display: flex;
      max-width: 100%;
      flex: 2;
      align-items: center;
    }
    img {
      flex: 1;
      width: 100%;
      max-width: 100%;
      max-height: 100%;
      height: auto;
      width: auto;
      align-self: center;
    }
  }
  .campaign-header {
    display: flex;
    @media (max-width: 720px) {
      flex-direction: column;
    }
    .cta-btn {
      width: 100%;
      height: 50px;
      font-weight: 600;
      width: 95%;
      margin: 10px;
      letter-spacing: 1px;
    }
    .image {
      flex: 2;
      img {
        width: 100%;
        max-width: 100%;
      }
    }
    .campaign-info-block {
      display: flex;
      flex: 1;
      flex-direction: column;
      background-color: whitesmoke;
      .social-links {
        padding: 10px 10px 0px 0px;
        color: black;
      }
      .campaign-info {
        align-items: flex-start;
        display: flex;
        flex: 1;
        flex-direction: column;
        padding: 0 20px;
        line-height: 40px;
        margin-bottom: 5px;
        justify-content: center;
        @media (max-width: 720px) {
          min-height: 60vh;
        }

        h1 {
          text-transform: uppercase;
        }
        .campaign-blurb {
          line-height: 25px;
        }
      }
    }
    progress {
      width: 100%;
    }
  }
  .campaign-about {
    // background-color: blue;
  }
}
</style>
